import Swiper, { Autoplay, Navigation } from 'swiper';
import { Fancybox } from "@fancyapps/ui/src/Fancybox/";
if (customElements.get('component-images') === undefined) {
    class Images extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.carousel = null;
            this.style.display = 'block';
            this.style.position = 'relative';
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Autoplay, Navigation],
                slidesPerView: 5,
                speed: 700,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2.6,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    900: {
                        slidesPerView: 5
                    },
                },
            });
            Fancybox.bind("[data-fancybox]", {
            // Your custom options
            });
        }
    }
    customElements.define('component-images', Images);
}
